module.exports = __webpack_public_path__ + "static/media/IntroSDGs.702ab973.jpg";